import { defineComponent as _defineComponent } from 'vue'
import useBreakpoint from '~/composables/useBreakpoint';
import { getAssetUrl } from '~/composables/useMediaAsset';
import handleImageAlt from '~/helpers/handleImageAlt';
import handleImageSrc from '~/helpers/handleImageSrc';
import { CdnImg } from '@webplatform/cdn-image';


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryChoosePlan',
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const gradients = [
  'from-[#432A9E] to-[#2050A7]',
  'from-[#635E78] to-[#485876]',
];



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const getPlanHeaderBg = (index: number) => gradients[index];

return { __sfc: true,gradients, isDesktop, getPlanHeaderBg, getAssetUrl, handleImageAlt, handleImageSrc, CdnImg }
}

})